import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";

const pathBase = `/notifications/sent/`;
const pathById = `${pathBase}:notificationId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const sent = {
  getAll: apiPathFunc(pathBase),
  get: apiPathFunc(pathById),
} as const;
